<script>
	import About from "./About.svelte";
	import Editor from "./Editor.svelte";
</script>

<main>
	<About />
	<Editor />
</main>

<style>
	@import url('https://fonts.googleapis.com/css2?family=EB+Garamond:wght@400;600&display=swap');

	main {
		padding: 1em;
		max-width: 500px;
		margin: 0 auto;
		font-family: 'EB Garamond', serif;
	}
</style>
